{
  "verse": {
    "loading": "در حال بارگذاری آیه...",
    "error": "بارگذاری آیه ممکن نشد",
    "reference": "— سوره {{surah}}، آیه {{ayah}}",
    "arabicUnavailable": "(متن عربی در دسترس نیست)",
    "english": "English",
    "arabic": "العربية",
    "swapLanguage_aria": "تعویض زبان",
    "toggleLanguage_title": "تغییر بین انگلیسی / عربی",
    "reflect": "تأمل",
    "reflecting": "در حال اندیشیدن…",
    "reflect_aria": "تأملی شخصی بسازید که این آیه را به نیت شما پیوند دهد",
    "insights": "بینش‌ها",
    "insights_aria": "گشودن بینش‌های قرآنی هوش مصنوعی",
    "share": "اشتراک‌گذاری",
    "share_aria": "اشتراک‌گذاری این آیه به‌صورت تصویر",
    "share_title": "اشتراک‌گذاری این آیه",
    "removeFromFavorites_aria": "حذف از علاقه‌مندی‌ها",
    "saveToFavorites_aria": "ذخیره در علاقه‌مندی‌ها",
    "favoritesProLocked_aria": "علاقه‌مندی‌ها یک ویژگی پرو است",
    "favoritesUpgrade_aria": "برای ذخیره علاقه‌مندی‌ها ارتقا دهید",
    "signInToSave": "برای ذخیره علاقه‌مندی‌ها وارد شوید.",
    "failedToUpdateFavorites": "به‌روزرسانی علاقه‌مندی‌ها ناموفق بود",
    "couldNotReflect": "ساخت تأمل ممکن نشد",
    "shareCaption": "«{{text}}»\n— سوره {{surah}}، آیه {{ayah}}\n\nrhemn.com",
    "imageSavedVerseCopied": "تصویر ذخیره شد · آیه کپی شد",
    "imageSaved": "تصویر آیه ذخیره شد",
    "couldNotCreateImage": "ساخت تصویر ممکن نشد"
  },
  "insights": {
    "panel_aria": "پنل بینش‌های قرآنی",
    "title": "بینش‌ها",
    "reference": "سوره {{surah}}، آیه {{ayah}}",
    "close_aria": "بستن پنل بینش‌ها",
    "versePreview_aria": "پیش‌نمایش آیه",
    "back_aria": "بازگشت",
    "tryAgain": "تلاش دوباره",
    "backTo_aria": "بازگشت به {{ref}}",
    "copyVerse_aria": "کپی {{ref}}",
    "openingVerse": "در حال باز کردن آیه…",
    "verseError": "آیه باز نشد."
  },
  "proGate": {
    "title": "بینش‌های قرآنی هوش مصنوعی یک ویژگی پرو است",
    "subtitleSafari": "Unlock deep, contextual understanding of every verse with Rhemn Pro. Already a member? It unlocks automatically when you sign in.",
    "subtitle": "درک عمیق و بافتاری هر آیه را بگشایید.",
    "bulletAsk": "هر پرسشی درباره آیه بپرسید",
    "bulletTafsir": "خلاصه‌های تفسیر فوری مبتنی بر هوش مصنوعی",
    "bulletRelated": "آیه‌های مرتبط موضوعی را کشف کنید",
    "upgrade": "ارتقا به پرو"
  },
  "ask": {
    "heading": "پرسش",
    "suggestion1": "بافت گسترده‌تر این آیه چیست؟",
    "suggestion2": "چگونه می‌توانم این را در زندگی روزمره به کار ببرم؟",
    "suggestion3": "علمای کلاسیک درباره این چه می‌گویند؟",
    "placeholder": "هر چه درباره این آیه می‌خواهید بپرسید…",
    "input_aria": "پرسشی درباره این آیه بپرسید",
    "submit_aria": "ارسال پرسش",
    "submit_title": "ارسال (⌘↵)",
    "submit_label": "پرسش",
    "submit_hint": "⌘↵",
    "suggestions_aria": "پرسش‌های پیشنهادی",
    "error": "دریافت پاسخ ممکن نشد.",
    "pending": "در حال تأمل در پرسش شما…",
    "attribution": "پاسخ تولیدشده با هوش مصنوعی · جایگزین دانش علمی صلاحیت‌دار نیست"
  },
  "tafsir": {
    "heading": "تفسیر",
    "emptyText": "خلاصه تفسیر تولیدشده با هوش مصنوعی برای این آیه را دریافت کنید.",
    "generate": "تولید تفسیر",
    "commentary": "شرح",
    "regenerate": "تولید مجدد",
    "regenerate_aria": "تولید مجدد تفسیر",
    "attribution": "خلاصه تولیدشده با هوش مصنوعی · جایگزین دانش علمی صلاحیت‌دار نیست",
    "error": "ساخت تفسیر ممکن نشد.",
    "pending": "در حال خواندن شرح…"
  },
  "related": {
    "heading": "آیه‌های مرتبط",
    "copied": "کپی شد: {{ref}}",
    "failedToCopy": "کپی ناموفق بود",
    "empty": "آیه مرتبطی یافت نشد.",
    "error": "بارگذاری آیات مرتبط ممکن نشد.",
    "pending": "در حال یافتن آیه‌های مرتبط…"
  },
  "favorites": {
    "panel_aria": "آیه‌های مورد علاقه",
    "title": "آیه‌های مورد علاقه",
    "proLocked": "علاقه‌مندی‌های آیه یک ویژگی پرو است.",
    "loading": "در حال بارگذاری…",
    "failedToLoad": "بارگذاری علاقه‌مندی‌ها ناموفق بود",
    "empty": "هنوز علاقه‌مندی‌ای نیست. روی قلب هر آیه ضربه بزنید تا ذخیره شود.",
    "reference": "— سوره {{surah}}، آیه {{ayah}}",
    "remove_aria": "حذف از علاقه‌مندی‌ها",
    "failedToRemove": "حذف ناموفق بود"
  }
}
